import React, { Fragment, useState, useContext, useEffect } from 'react';
import {
  Button,
  Paper,
  IconButton,
  InputAdornment,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useStyles } from '../../styles/Styles';
import DocumentUploadContext from '../../context/DocumentUpload/documentUploadContext';
import NotificationContext from '../../context/Notification/notificationContext';
import Notification from '../notification/Notification';
import Spinner from '../spinner/Spinner';
import CloseIcon from '@material-ui/icons/Close';
import NumberFormat from 'react-number-format';
const OTP = (props) => {
  const classes = useStyles(); //Use Styles from styles/styles.js
  const { handleClose } = props;
  //Use documentUploadContext from context/DocumentUploadContext
  const documentUploadContext = useContext(DocumentUploadContext);
  const notificationContext = useContext(NotificationContext);
  const {
    validateOTP,
    userInfo,
    errors,
    clearErrors,
    requestForOTP,
    otpRequest,
    loading,
    CheckifSoftLock,
    applicationDetails,
    setNominatedPin,
    setOldPin,
    atmCardNumberDetails,
    submitNominatedPin,
    submitNewNominatedPin,
    atmCardValidation
  } = documentUploadContext;
  const [values, setValues] = useState({
    otp: '',
    showOTP: false,
  });
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowOTP = () => {
    setValues({ ...values, showOTP: !values.showOTP });
  };

  const handleMouseDownOTP = (event) => {
    event.preventDefault();
  };

  const currentURL = window.location.href;

  //Submit Form
  const handleSubmitClick = (e) => {
    e.preventDefault();
      if (values.otp !== '') {
          if (CheckifSoftLock('FAILEDOTPTRY', 'LOCKOTPTIME')) {
            if (currentURL.includes("Scheduler"))
            {
              validateOTP(applicationDetails.mobileNumber, values.otp);
            }
            else if (currentURL.toLowerCase().includes("activatecard"))
            {
              //validateOTP('09563869524', values.otp);
              //submitNominatedPin('09563869524', values.otp, atmCardNumberDetails, setNominatedPin, setNominatedPin);
              submitNominatedPin(atmCardValidation.mobileNumber, values.otp, atmCardNumberDetails, setNominatedPin, setNominatedPin);
              ///console.log(atmCardNumberDetails);
              //console.log(setNominatedPin);
              //console.log(atmCardValidation.mobileNumber);
            } 
            else if (currentURL.toLowerCase().includes("changepin"))
            {
              //validateOTP('09563869524', values.otp);
              submitNewNominatedPin(atmCardValidation.mobileNumber, values.otp, atmCardNumberDetails, setOldPin, setNominatedPin, setNominatedPin);
              ///console.log(atmCardNumberDetails);
              //console.log(setNominatedPin);
              //console.log(atmCardValidation.mobileNumber);
            }  
            else {
              validateOTP(userInfo.mobileNumber, values.otp);
            }
          }
      
    } else if (values.otp === '') {
      notificationContext.setNotification('OTP must not be empty', 'error');
      clearErrors();
    }
  };

  const resendOTP = () => {
      setValues('');
      if (currentURL.includes("Scheduler")) {
          otpRequest(applicationDetails.mobileNumber);
      }
      else if (currentURL.toLowerCase().includes("activatecard")) {
          otpRequest(atmCardValidation.mobileNumber);
      }
      else if (currentURL.toLowerCase().includes("changepin")) {
          otpRequest(atmCardValidation.mobileNumber);
      }
      else {
          requestForOTP(userInfo.mobileNumber);
      }  
  };

  const close = () => {
    ////('handleClose');
    handleClose();
  };

  //Initializes when page loads
  useEffect(() => {
    if (errors != null) {
      notificationContext.setNotification(errors, 'error');
      clearErrors();
      ////(errors);
    }
  });
  return (
    <div>
      <div className={classes.otpOverlay}>
        <div className={classes.otpBackground}>
          <Paper className={classes.otpPaper}>
            <Button
              aria-label='close'
              className={classes.closeButton}
              onClick={() => close()}
            >
              <CloseIcon />
            </Button>

            <Notification />
            <br />
            <Typography
              variant='h5'
              style={{ color: '#0055A5', fontWeight: 600 }}
            >
              One-Time Password
            </Typography>
            <h4 style={{ paddingBottom: '10px' }}>
              We have sent a One-Time Password (OTP) to
              your mobile number used during application.
            </h4>
            {loading ? (
              <Spinner />
            ) : (
              <Fragment>
                <h4>Please enter the OTP in the box below to proceed.</h4>

                {loading ? (
                  <Spinner />
                ) : (
                  <Fragment>
                    <TextField
                      type={values.showOTP ? 'text' : 'password'}
                      variant='outlined'
                      value={values.otp}
                      onChange={handleChange('otp')}
                      style={{ width: '80%' }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton
                              style={{ color: '#0055A5' }}
                              onClick={handleClickShowOTP}
                              onMouseDown={handleMouseDownOTP}
                            >
                              {values.showOTP ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                        inputComponent: NumberFormat,
                      }}
                    />
                    <Grid
                      container
                      spacing={2}
                      direction='row'
                      justify='center'
                      alignItems='center'
                    >
                      <Grid item md={2}>
                        <Button
                          className={classes.otpSubmit}
                          variant='contained'
                          color='primary'
                          type='submit'
                          onClick={handleSubmitClick}
                        >
                          Submit
                        </Button>
                      </Grid>
                      {/* {values.otp === '' ? (
                        <Grid item md={2}>
                          <Button
                            style={{
                              textAlign: 'right',
                              textTransform: 'capitalize',
                              fontSize: '12px',
                              width: '100%',
                              marginTop: '15%',
                            }}
                            variant='contained'
                            color='primary'
                            type='submit'
                            onClick={handleSubmitClick}
                            disabled
                          >
                            Submit
                          </Button>
                        </Grid>
                      ) : (
                        <Grid item md={2}>
                          <Button
                            className={classes.otpSubmit}
                            variant='contained'
                            color='primary'
                            type='submit'
                            onClick={handleSubmitClick}
                          >
                            Submit
                          </Button>
                        </Grid>
                      )} */}
                    </Grid>
                    <Grid
                      item
                      container
                      direction='row'
                      justify='center'
                      alignItems='center'
                    >
                      <Button className={classes.otpResend} onClick={resendOTP}>
                        Resend Code
                      </Button>
                    </Grid>
                  </Fragment>
                )}
              </Fragment>
            )}
          </Paper>
        </div>
      </div>
    </div>
  );
};

export default OTP;
